<template>
	<div>
		<!-- Turnovers -->
		<div class="xs-12 fs5 fw7 mb2 mt6">Turnovers</div>
		<case-form :isBoxed="true" :schema="schemaTurnovers" />

		<!-- Benefits -->
		<products-liability-benefits class="mt6">
			<!-- Currency -->
			<case-form :isBoxed="false" :schema="schemaCurrency" />
		</products-liability-benefits>

		<!-- Custom Benefits -->
		<products-liability-benefits-custom class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../CaseForm/CaseForm"
import OfferForm from "./OfferForm.vue"
import ProductsLiabilityBenefits from "./ProductsLiabilityBenefits"
import ProductsLiabilityTurnoverFact from "./ProductsLiabilityTurnoverFact"
import ProductsLiabilityBenefitsCustom from "./ProductsLiabilityBenefitsCustom"

export default {
	components: {
		CaseForm,
		OfferForm,
		ProductsLiabilityBenefits,
		ProductsLiabilityTurnoverFact,
		ProductsLiabilityBenefitsCustom
	},

	data() {
		return {
			currencies: [
				{
					name: "AED",
					value: "AED"
				},
				{
					name: "AUD",
					value: "AUD"
				},
				{
					name: "BND",
					value: "BND"
				},
				{
					name: "EUR",
					value: "EUR"
				},
				{
					name: "IDR",
					value: "IDR"
				},
				{
					name: "INR",
					value: "INR"
				},
				{
					name: "KRW",
					value: "KRW"
				},
				{
					name: "LKR",
					value: "LKR"
				},
				{
					name: "MUR",
					value: "MUR"
				},
				{
					name: "MYR",
					value: "MYR"
				},
				{
					name: "PHP",
					value: "PHP"
				},
				{
					name: "PKR",
					value: "PKR"
				},
				{
					name: "QAR",
					value: "QAR"
				},
				{
					name: "SAR",
					value: "SAR"
				},
				{
					name: "SGD",
					value: "SGD"
				},
				{
					name: "THB",
					value: "THB"
				},
				{
					name: "USD",
					value: "USD"
				},
				{
					name: "TWD",
					value: "TWD"
				},
				{
					name: "CNY",
					value: "CNY"
				},
				{
					name: "JPY",
					value: "JPY"
				},
				{
					name: "OMR",
					value: "OMR"
				},
				{
					name: "HKD",
					value: "HKD"
				},
				{
					name: "GBP",
					value: "GBP"
				}
			]
		}
	},

	computed: {
		schemaCurrency() {
			return [
				{
					label: "Contract Currency",
					component: "select",
					props: {
						options: this.currencies
					},
					bindTo: "case.facts.currency"
				}
			]
		},

		schemaTurnovers() {
			return [
				{
					label: "Turnover in Asia (Including Domestic Sales/Turnover)",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderTurnoverInAsiaId",
					props: {
						suggest: {
							typeIs: "turnoverInAsia"
						},
						createOptions: {
							type: "turnoverInAsia",
							dataType: "object",
							value: {
								componentObject: {
									source: ProductsLiabilityTurnoverFact
								}
							}
						}
					}
				},
				{
					label: "Turnover in Australia/New Zealand",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderTurnoverInAustraliaId",
					props: {
						suggest: {
							typeIs: "turnoverInAustralia"
						},
						createOptions: {
							type: "turnoverInAustralia",
							dataType: "object",
							value: {
								componentObject: {
									source: ProductsLiabilityTurnoverFact
								}
							}
						}
					}
				},
				{
					label: "Turnover in Europe",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderTurnoverInEuropeId",
					props: {
						suggest: {
							typeIs: "turnoverInEurope"
						},
						createOptions: {
							type: "turnoverInEurope",
							dataType: "object",
							value: {
								componentObject: {
									source: ProductsLiabilityTurnoverFact
								}
							}
						}
					}
				},
				{
					label: "Turnover in North America (USA & Canada)",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderTurnoverInAmericaId",
					props: {
						suggest: {
							typeIs: "turnoverInAmerica"
						},
						createOptions: {
							type: "turnoverInAmerica",
							dataType: "object",
							value: {
								componentObject: {
									source: ProductsLiabilityTurnoverFact
								}
							}
						}
					}
				},
				{
					label: "Turnover in Rest of the World",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderTurnoverInWorldId",
					props: {
						suggest: {
							typeIs: "turnoverInWorld"
						},
						createOptions: {
							type: "turnoverInWorld",
							dataType: "object",
							value: {
								componentObject: {
									source: ProductsLiabilityTurnoverFact
								}
							}
						}
					}
				}
			]
		}
	}
}
</script>
